import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

function UserStats({ userStats }) {
    return (
        <div>
            <h2>Registrierte User pro Monat</h2>
            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={userStats}>
                    <XAxis dataKey="month" />
                    <YAxis />
                    <Tooltip />
                    <Bar dataKey="user" fill="#8884d8" />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}

export default UserStats;